// extracted by mini-css-extract-plugin
export default {"wrapper":"Sx-z","button":"Tx-z","alternate":"Ux-z","disabled":"Vx-z","paymentWarning":"Wx-z","fadeIn":"Xx-z"};